import * as React from "react"
import { useState } from "react"
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'

import { h3, body, bodyLarge } from "../commonStyles/Fonts";

import { styled } from "../../stitches.config"
import Link from "../../components/Link";
import Footer from "../components/Footer"
import { resetPassword } from "../../api/account"

type ResetPassportFormValues = {
    email: string;
}

// TODO animacja submitowania/ostylować błędy logowania/informacja o sprawdzeniu skrzynki email
const ResetPassword: React.FC = () => {
    const [submitting, setSubmitting] = useState<boolean>(false)
    const [submitted, setSubmitted] = useState<boolean>(false)
    const initialValues: ResetPassportFormValues = { email: "" }
    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .required("Pole wymagane")
            .email("Wprowadź poprawny adres e-mail"),
    })

    const handleSubmit = ({ email }: ResetPassportFormValues) => {
        setSubmitting(true)
        resetPassword({ email })
            .then(res => {
                console.log(res)
                setSubmitted(true)
            })
            .catch(err => {
                console.log(err)
                setSubmitting(false)
            })
    }

    return <>
        <Overlay>
            <FormWrapper>
                {submitted ? <div>sprawdź skrzynkę</div> :
                    <>
                        <FormTitle>
                            <p className={h3()}>Nie pamiętasz hasła?</p>
                        </FormTitle>
                        <FormText className={bodyLarge()}>Podaj swój adres email, powiązany z kontem na<span>:</span>Temat. Wyślemy Ci link do zmiany hasła.</FormText>
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}>
                            {({ errors, touched }) => (
                                <Form className={body()}>
                                    <label className={`${errors.email && touched.email && "show-error-input-text"}`} htmlFor="email">Email</label>
                                    <Field
                                        type="text"
                                        name="email"
                                        className={`${bodyLarge()} ${errors.email && touched.email && "show-error-input-border"}`}
                                        disabled={submitting}
                                        placeholder="Wpisz swój email" />
                                    {errors.email && touched.email && <span className="validationError">{errors.email}</span>}
                                    <button
                                        type="submit"
                                        className={bodyLarge()}
                                        disabled={submitting}>
                                        Wyślij
                                    </button>
                                </Form>
                            )}
                        </Formik>
                        <FormWrapperLink className={bodyLarge()}>
                            <Link to="/login">
                                Wróć do logowania
                            </Link>
                        </FormWrapperLink>
                    </>}
            </FormWrapper>
        </Overlay>
        <Footer />
    </>
}

const Overlay = styled("div", {
    position: "relative",
    backgroundColor: "white",
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    minHeight: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "$grayscale10",
    "@bp2": {
        padding: "72px 0 80px 0",
    }
})

const FormTitle = styled("div", {
    "& p": {
        width: "332px",
        margin: 0,
    },
})

const FormText = styled("p", {
    width: "332px",
    margin: "8px 0 0 0",
    "& span": {
        color: "$primary",
    }
})

const FormWrapper = styled("div", {
    padding: "32px 16px 32px 16px",
    color: "$grayscale100",
    background: "$grayscale0",
    "@bp2": {
        width: "auto",
        padding: "36px 40px 32px 40px",
    },
    "& form": {
        display: "flex",
        flexDirection: "column",
        "& label": {
            margin: "24px 0 4px 0"
        },
        "& input": {
            border: "1px solid $grayscale25",
            caretColor: "$primary",
            color: "$grayscale100Fixed",
            "&:hover": {
                border: "1px solid $grayscale50",
            },
            "&:focus": {
                border: "1px solid $grayscale50",
            },
            "&::placeholder": {
                color: "$grayscale50",
            },
        },
        "& input, button": {
            fontWeight: "500",
            padding: "12px 14px",
            transition: "0.2s",
        },
        "& button": {
            background: "$primary",
            borderWidth: "0px",
            color: "$grayscale0",
            margin: "24px 0",
        },
        "& a": {
            color: "$grayscale75",
            marginTop: "6px",
            textDecoration: "underline",
            "& span": {
                fontSize: "12px",
                lineHeight: "16px",
            }
        }
    },
    "& .validationError": {
        color: "$aszdziennikPrimary",
        fontSize: "12px",
        lineHeight: "16px",
        marginTop: "8px",
    },
    ".show-error-input-border": {
        border: "1px solid $aszdziennikPrimary",
        "&:hover": {
            border: "1px solid $aszdziennikPrimary",
        },
        "&:focus": {
            border: "1px solid $aszdziennikPrimary",
        },
    },
    ".show-error-input-text": {
        color: "$aszdziennikPrimary",
    }
})

const FormWrapperLink = styled("div", {
    width: "100%",
    display: "flex",
    "& a": {
        margin: "0 auto",
        color: "$grayscale100",
        "& span": {
            color: "$primary",
        },
        "&:hover": {
            textDecoration: "none",
        }
    }
})

export default ResetPassword